/* eslint-disable no-nested-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import floor from 'lodash/floor'

const TextField = ({
  input,
  label,
  type,
  meta,
  placeholder,
  // css classes
  errorClassName,
  groupClassName,
  inputClassName,
  inputErrorClassName,
  labelClassName,
  suffix,
  disabled,
  count,
  isNotable_tenants,
  instruction,
  minDate,
}) => {
  const length = isNotable_tenants
    ? input.value
      ? input.value.split(',').length
      : 0
    : input.value.length
  const renderCharacterCount = (
    <div className="pt-1 flex flex-col w-full">
      <div className={`w-full h-2 rounded bg-secondary-graywhite bg-count`}>
        <div
          className={`h-full rounded  ${length < count ? 'bg-primary-green' : 'bg-free-speech-red'
            }`}
          style={{
            width: `${floor((length / count) * 100 > 100 ? 100 : (length / count) * 100)}%`,
          }}
        ></div>
      </div>
      <div className="count text-xs text-right text-primary-lightgray flex justify-between">
        <span>{instruction}</span>
        {`(${length}/${count})`}
      </div>
    </div>
  )

  return (
    <>
      <div className={groupClassName}>
        <label className={labelClassName}>
          {label} {suffix}
        </label>
        <input
          {...input}
          min={minDate}
          onChange={(e) => {
            const value = isNotable_tenants ? e.target.value.split(',') : e.target.value

            const isValidValue = (count && value.length <= count) || !count
            const inputValue = e.target.defaultValue
            const isRemove = (inputValue.length > value.length) && !isNotable_tenants

            if (isValidValue || isRemove) {
              input.onChange(e.target.value)
            }
          }}
          className={
            meta.touched && meta.error
              ? [inputClassName, inputErrorClassName].join(' ')
              : inputClassName
          }
          placeholder={placeholder}
          type={type}
          disabled={disabled}
        />
        {count && renderCharacterCount}
        {meta.touched && meta.error && <p className={errorClassName}>{meta.error}</p>}
      </div>
    </>
  )
}

TextField.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  groupClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  inputErrorClassName: PropTypes.string,
  suffix: PropTypes.node,
  disabled: PropTypes.bool,
  count: PropTypes.number,
  isNotable_tenants: PropTypes.bool,
  instruction: PropTypes.string,
  isFormat: PropTypes.bool,
  minDate: PropTypes.string,
  onClickCustom: PropTypes.func,
}

export default TextField
